"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../textInfo.scss");
const utils_1 = require("../utils");
const Span = (props) => {
    const { cySelector } = props;
    let { text } = props;
    text = { __html: text };
    const myClassName = (0, utils_1.createCssClassByProps)(props);
    return (react_1.default.createElement("span", { className: myClassName, dangerouslySetInnerHTML: text, "cy-data": cySelector }));
};
exports.default = Span;
//# sourceMappingURL=index.js.map